import { useSelector } from 'react-redux';
import { useProductSummaryImage } from '../hooks/useProductSummaryImage';
import { selectMockImages } from '../../../../redux/mockImagesSlice';
import React from 'react';

const Image = () => {
	const fallback = '/images/26000ConjuntoAlfaiatariaNuancePink.webp';
	const { height, width, maxHeight, blockClass, componentId } = useProductSummaryImage();
	const imageList = useSelector(selectMockImages);
	const [list, setList] = React.useState([fallback]);

	React.useEffect(() => {
		setList(imageList?.['shelf']);
	}, [imageList]);

	const renderStyles = () => {
		if (!width && !height && !maxHeight) {
			return {};
		}

		return {
			width: '100%',
			maxWidth: `${width || height || '100%'}${(width || height) && 'px'}`,
			height: `${height || width || '100%'}${(width || height) && 'px'}`,
			objectFit: 'contain' as const,
			maxHeight: `${maxHeight || 'unset'}${maxHeight && 'px'}`,
		};
	};

	return (
		<img
			data-selection={componentId}
			src={`${list?.length ? list[Math.floor(Math.random() * list.length)] : fallback}?v=637852979295600000=${width || height || '500'}&height=${height || width || ''}&aspect=true`}
			className={`imageNormal image ${blockClass ? `image--${blockClass} vtex-product-summary-2-x-image--${blockClass}` : ''} vtex-product-summary-2-x-imageNormal vtex-product-summary-2-x-image`}
			alt=""
			style={renderStyles()}
		/>
	);
};

export default Image;
